import React, { useMemo, useState } from "react";
import { Form, SimpleItem } from "devextreme-react/ui/form";
import CollapseSection from "../../../components/CollaspeSection";
import { useQuery } from "@tanstack/react-query";
import AcquisitionsAPI from "../../../api/acquisitions/index.js";
import {
  applyTimeIntervalSelection,
  cloneReportInfoForForm,
  getTimeIntervalVisibility,
} from "./report-params-utils";

const AcquisitionParamsForm = ({ paramsForm, reportInfo }) => {
  const [editorVisiblity, setEditorVisbility] = useState(() => {
    const { startDate, endDate } = getTimeIntervalVisibility(
      reportInfo?.report_parameters?.time_interval
    );
    return { startDate, endDate };
  });

  const { data: statuses } = useQuery({
    queryKey: ["acquisitions:statuses"],
    queryFn: () => AcquisitionsAPI.getStatuses(),
    initialData: [
      { status: "Active", status_id: 1, color: "limegreen" },
      { status: "Deleted", status_id: 2, color: "orangered" },
    ],
  });

  // "All" is the blank default; selecting it reverts the box to its
  // placeholder rather than storing a value (see onValueChanged below).
  const statusOptions = useMemo(
    () => [{ status: "All" }, ...statuses],
    [statuses]
  );

  let startDateRef = null;
  let endDateRef = null;

  return (
    <>
      <CollapseSection
        title={"Report Parameters | Acquisition - Overview"}
        allowCollapse={false}
      >
        <Form
          ref={paramsForm}
          colCount={2}
          defaultFormData={cloneReportInfoForForm(reportInfo)}
        >
          <SimpleItem
            dataField="report_parameters.time_interval"
            label={{ text: "Time Interval" }}
            colSpan={1}
            editorType="dxSelectBox"
            editorOptions={{
              items: [
                "All Time",
                "Custom",
                "Today",
                "Yesterday",
                "This Week",
                "Last Week",
                "This Month",
                "Last Month",
                "This Year",
                "Last Year",
              ],
              placeholder: "All Time",
              dropDownOptions: {
                maxHeight: 250,
              },
              onValueChanged: (e) => {
                const interval = applyTimeIntervalSelection(
                  e,
                  paramsForm.current?.instance,
                  []
                );
                const { startDate, endDate } =
                  getTimeIntervalVisibility(interval);
                setEditorVisbility({ ...editorVisiblity, startDate, endDate });
              },
            }}
          />
          <SimpleItem
            dataField="report_parameters.status"
            label={{ text: "Acquisition Status" }}
            colSpan={1}
            editorType="dxSelectBox"
            editorOptions={{
              displayExpr: "status",
              valueExpr: "status",
              items: statusOptions,
              placeholder: "All",
              showClearButton: true,
              dropDownOptions: {
                maxHeight: 250,
              },
              onValueChanged: (e) => {
                if (e.value === "All") {
                  e.component.option("value", null);
                }
              },
            }}
          />
          <SimpleItem
            dataField="report_parameters.start_date"
            label={{ text: "Start Date" }}
            editorType="dxDateBox"
            colSpan={1}
            isRequired={true}
            visible={editorVisiblity.startDate}
            editorOptions={{
              onInitialized: (e) => {
                startDateRef = e.component;
              },
              onValueChanged: (e) => {
                endDateRef.option("min", e.value);
              },
            }}
          />
          <SimpleItem
            dataField="report_parameters.end_date"
            label={{ text: "End Date" }}
            editorType="dxDateBox"
            colSpan={1}
            isRequired={true}
            visible={editorVisiblity.endDate}
            editorOptions={{
              onInitialized: (e) => {
                endDateRef = e.component;
              },
              onValueChanged: (e) => {
                startDateRef.option("max", e.value);
              },
            }}
          />
        </Form>
      </CollapseSection>
    </>
  );
};

export default AcquisitionParamsForm;
